import React from 'react';
import { FadeIn } from './FadeIn';
import { trackPixelEvent } from '../lib/metaPixel';
const trustItems = [{
  icon: '🔒',
  label: 'Pago procesado por Hotmart'
}, {
  icon: '📥',
  label: 'Acceso digital inmediato'
}, {
  icon: '🛡',
  label: 'Garantía de 7 días'
}];
export function FinalCTASection() {
  return <section className="py-16 md:py-24 bg-brand-forest text-white text-center" data-id="element-24" data-mp="utqdpqtrk2z">
      <div className="max-w-3xl mx-auto px-6" data-id="element-25" data-mp="2ze0mti0nm8j2">
        <FadeIn data-id="element-26" data-mp="2zfbs5m9qzoca">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-4 leading-tight" data-id="element-27" data-mp="2zbnvwfcx4ntv">
            No necesitas
            <br data-id="element-28" data-mp="39by7xwn7vp7g" />
            cambiarlo todo hoy.
          </h2>
          <p className="text-xl md:text-2xl text-brand-mint font-serif italic mb-4" data-id="element-29" data-mp="399llb66ikqo2">
            Solo necesitas empezar con el Día 1.
          </p>
          <p className="text-sm text-white/70 mb-10" data-id="element-30" data-mp="2gnsqbirgmgbu">
            21 días · 3 fases · herramientas prácticas
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-31" data-mp="2lk9eue2kmwpg">
          <a href="https://pay.hotmart.com/P106181864L?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('AddToCart', {
          content_name: 'Desintoxica tu Mente en 21 Días',
          content_type: 'product',
          currency: 'USD',
          value: 19.99
        })} className="inline-block text-center bg-brand-terracotta text-white px-8 py-4 rounded-full text-base sm:text-lg md:text-xl font-bold hover:bg-[#b05626] active:scale-[0.98] transition-[background-color,transform] duration-150 ease-out shadow-xl mb-8 w-full sm:w-auto" data-id="element-32" data-mp="26v0yay5eyu1q">
            QUIERO EMPEZAR MIS 21 DÍAS — $19.99 →
          </a>

          <ul className="flex flex-col sm:flex-row sm:flex-wrap justify-center gap-3 sm:gap-6 text-sm font-medium text-white/90" data-id="element-33" data-mp="199d48jwfkntd">
            {trustItems.map(item => <li key={item.label} className="flex items-center justify-center gap-2" data-id="element-34" data-mp="33ml1ei7vpbi6">
                <span aria-hidden="true" data-id="element-35" data-mp="11uavebhhefia">{item.icon}</span>
                {item.label}
              </li>)}
          </ul>
        </FadeIn>
      </div>
    </section>;
}